import { render, staticRenderFns } from "./WhiteboardColorPickerModal.vue?vue&type=template&id=3e4d1529&scoped=true&"
import script from "./WhiteboardColorPickerModal.vue?vue&type=script&lang=js&"
export * from "./WhiteboardColorPickerModal.vue?vue&type=script&lang=js&"
import style0 from "./WhiteboardColorPickerModal.vue?vue&type=style&index=0&id=3e4d1529&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d1529",
  null
  
)

export default component.exports